import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed, nextTick } from 'vue';
import { useI18n } from '../../../locales';
import TuiButton from '../../common/base/Button.vue';
import Dialog from '../../common/base/Dialog';
import TuiInput from '../../common/base/Input';
import SvgIcon from '../../common/base/SvgIcon.vue';
import ArrowUpIcon from '../../common/icons/ArrowUpIcon.vue';
import useMemberControlHooks from './useMemberControlHooks';
import useMemberItemHooks from '../MemberItem/useMemberItemHooks';
import { UserInfo } from '../../../stores/room';

interface Props {
  userInfo: UserInfo;
  showMemberControl: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberControlPC',
  props: {
    userInfo: null,
    showMemberControl: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo;
  showMemberControl: boolean;
};



const { t } = useI18n();
const {
  controlList,
  handleCancelDialog,
  handleAction,
  isDialogVisible,
  dialogData,
  tempUserName,
} = useMemberControlHooks(props);

const { isCanOperateMySelf } = useMemberItemHooks(props.userInfo);

const singleControl = computed(() => controlList.value[0]);
const moreControlList = computed(() => {
  return isCanOperateMySelf ? controlList.value : controlList.value.slice(1);
});
const dropdownClass = ref('down');
const moreBtnRef = ref();
const operateListRef = ref();
const showMoreControl = ref(false);

watch(
  () => props.showMemberControl,
  val => {
    if (!val) {
      showMoreControl.value = false;
    }
  }
);

async function toggleClickMoreBtn() {
  if (showMoreControl.value) {
    showMoreControl.value = false;
  } else {
    await handleDropDownPosition();
    showMoreControl.value = true;
  }
}

async function handleDropDownPosition() {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { top, bottom } = moreBtnRef.value?.getBoundingClientRect();
  const { top: containerTop, bottom: containerBottom } = document
    .getElementById('memberListContainer')
    ?.getBoundingClientRect() as DOMRect;
  if (!containerBottom || !containerTop) {
    return;
  }
  const bottomSize = containerBottom - bottom;
  const topSize = top - containerTop;
  let dropDownContainerHeight = 0;
  if (!showMoreControl.value) {
    operateListRef.value.style =
      'display:block;position:absolute;z-index:-1000';
    await nextTick();
    dropDownContainerHeight = operateListRef.value.offsetHeight;
    operateListRef.value.style = '';
  } else {
    dropDownContainerHeight = operateListRef.value?.offsetHeight;
  }
  if (topSize < dropDownContainerHeight) {
    return;
  }
  if (bottomSize < dropDownContainerHeight) {
    dropdownClass.value = 'up';
  }
}

return { __sfc: true,props, t, controlList, handleCancelDialog, handleAction, isDialogVisible, dialogData, tempUserName, isCanOperateMySelf, singleControl, moreControlList, dropdownClass, moreBtnRef, operateListRef, showMoreControl, toggleClickMoreBtn, handleDropDownPosition, TuiButton, Dialog, TuiInput, SvgIcon, ArrowUpIcon }
}

})